document.addEventListener('click', (evt) => {
  const openBtn = evt.target.closest('[data-shopping-highlights-open]');
  if (openBtn) {
    const id = openBtn.dataset.shoppingHighlightsOpen;
    const popup = document.getElementById(`ShoppingHighlightsPopup-${id}`);
    if (popup) {
      popup.hidden = false;
      document.body.style.overflow = 'hidden';
      const closeBtn = popup.querySelector('.shopping-highlights-popup__close');
      if (closeBtn) closeBtn.focus();
    }
    return;
  }

  const closeEl = evt.target.closest('[data-shopping-highlights-close]');
  if (closeEl) {
    const id = closeEl.dataset.shoppingHighlightsClose;
    const popup = document.getElementById(`ShoppingHighlightsPopup-${id}`);
    if (popup) {
      popup.hidden = true;
      document.body.style.overflow = '';
    }
  }
});

document.addEventListener('keyup', (evt) => {
  if (evt.key !== 'Escape') return;
  document.querySelectorAll('.shopping-highlights-popup:not([hidden])').forEach((popup) => {
    popup.hidden = true;
    document.body.style.overflow = '';
  });
});
